import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a02ce3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center gap-5" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "required mb-1" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  for: "",
  class: "required mb-1"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = {
  for: "",
  class: "required mb-1"
}
const _hoisted_11 = { class: "w-100 px-10" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Conditions", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#ffcccb","border-radius":"10px","padding":"1px 10px","margin-top":"10px","width":"100%","text-align":"center"} }, " Start Date 21:00 - End Date 21:00 ", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "d-flex mt-5" }

import moment from "moment";
import { nextTick, ref, watch } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import SimpleForm from "@/components/SimpleForm.vue";
import { isDateInDST_US } from "@/core/plugins/TimerService";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import ReportService from "@/projects/tenant/modules/report/services/ReportService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesReportExportModal',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {


const modalRef = ref();
const isLoading = ref(false);
const exporting = ref(false);
const period = ref([] as any);
const checkAll = ref(false);
const isIndeterminate = ref(true);
const columns = [
  "Date",
  "Email",
  "Sales Account",
  "Code",
  "Start Equity",
  "Last Equity",
  "Client Deposit",
  "Deposit Transfer",
  "Client Withdrawal",
  "Withdrawal Transfer",
  "IB Withdrawal",
  "IB Rebate",
  "Sales Rebate",
  "Net Deposit",
  "Adjust",
  "Credit",
  "P/L",
  "Net P/L",
  "Lots",
];

const defaultTime = ref<[Date, Date]>([
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 2, 1, 23, 59, 59),
]);

const formData = ref({
  name: "",
  type: "",
  site: "vn",
  from: null,
  to: null,
  salesAccountNumbers: "",
  currencyId: 840,
  checkedColumn: ["Date", "Email", "Sales Account", "Code"],
} as any);

const handleCheckAllChange = (val: any) => {
  formData.value.checkedColumn = val ? columns : [];
  isIndeterminate.value = false;
};
const handlecheckedColumnChange = (value: any[]) => {
  const checkedCount = value.length;
  checkAll.value = checkedCount === columns.length;
  isIndeterminate.value = checkedCount > 0 && checkedCount < columns.length;
};

const submit = async () => {
  exporting.value = true;

  await ReportService.createSalesReport(formData.value).then(
    MsgPrompt.success(
      "Request has been submitted, please check the Report Record"
    ).then(() => {
      emits("fetchData");
      exporting.value = false;
      resetFormData();
      formData.value.name = null;
      formData.value.type = null;
      hide();
    })
  );
};

const resetFormData = () => {
  period.value = [];
  formData.value.from = null;
  formData.value.to = null;
  formData.value.salesAccountNumbers = "";
  formData.value.checkedColumn = ["Date", "Email", "Sales Account", "Code"];
};

const show = async () => {
  formData.value.name = "";
  formData.value.type = "";
  formData.value.site = "vn";
  resetFormData();
  modalRef.value?.show();
};

const hide = () => {
  modalRef.value?.hide();
};

watch(
  () => period.value,
  (periodVal) => {
    const [from, to] = periodVal;
    const isDST = isDateInDST_US();
    formData.value.from = from ? moment(from).format(`YYYY-MM-DD`) : null;
    formData.value.to = to ? moment(to).format(`YYYY-MM-DD`) : null;
  }
);

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.export'),
    "is-loading": isLoading.value,
    width: 600,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("title.recordName")), 1),
          _createVNode(_component_el_input, {
            class: "w-400px",
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createVNode(_component_el_select, {
                modelValue: formData.value.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Include All",
                    value: "all"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Direct Client",
                    value: "direct"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Direct Detail",
                    value: "detail"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createVNode(_component_el_select, {
                modelValue: formData.value.site,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.site) = $event)),
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "VN",
                    value: "vn"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_button, { onClick: resetFormData }, {
              default: _withCtx(() => [
                _createTextVNode("Reset Conditions")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form, {
            "label-width": "auto",
            class: "border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "mt-3",
                label: "Date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: period.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((period).value = $event)),
                    type: "daterange",
                    "start-placeholder": _ctx.$t('fields.startDate'),
                    "end-placeholder": _ctx.$t('fields.endDate'),
                    "default-time": defaultTime.value,
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "default-time", "disabled"]),
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Sales Uids" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.salesAccountNumbers,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.salesAccountNumbers) = $event)),
                    placeholder: "Sales Uids",
                    type: "textarea",
                    clearable: "",
                    disabled: exporting.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Currency" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.currencyId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.currencyId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "USD",
                        value: "840"
                      }),
                      _createVNode(_component_el_option, {
                        label: "USC",
                        value: "841"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (formData.value.type != 'detail')
                ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
                : _createCommentVNode("", true),
              (formData.value.type != 'detail')
                ? (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: 1,
                    modelValue: checkAll.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checkAll).value = $event)),
                    indeterminate: isIndeterminate.value,
                    onChange: handleCheckAllChange
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Check all ")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "indeterminate"]))
                : _createCommentVNode("", true),
              (formData.value.type != 'detail')
                ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                    key: 2,
                    modelValue: formData.value.checkedColumn,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.checkedColumn) = $event)),
                    onChange: handlecheckedColumnChange
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (city) => {
                          return _createVNode(_component_el_checkbox, {
                            class: "col-3",
                            key: city,
                            label: city,
                            value: city
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(city), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"])
                        }), 64))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: exporting.value,
            onClick: submit,
            disabled: !formData.value.type || !formData.value.name || !formData.value.site
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_el_button, { onClick: hide }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})